import { render } from "./Reward.vue?vue&type=template&id=52dbc3f2&scoped=true"
import script from "./Reward.vue?vue&type=script&lang=js"
export * from "./Reward.vue?vue&type=script&lang=js"

import "./Reward.vue?vue&type=style&index=0&id=52dbc3f2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52dbc3f2"],['__file',"src/components/elements/Reward.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "52dbc3f2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('52dbc3f2', __exports__)) {
    api.reload('52dbc3f2', __exports__)
  }
  
  module.hot.accept("./Reward.vue?vue&type=template&id=52dbc3f2&scoped=true", () => {
    api.rerender('52dbc3f2', render)
  })

}


export default __exports__